import hyperform from "hyperform"
import maskInput from "vanilla-text-mask"
import { q, qq } from "../../helper/q"
import { NSerializeJson } from "nserializejson"
import { safeGet } from "../../helper/safe"
import pose from "popmotion-pose"

const state = {
  part: 1
}

export const paymentFormInit = () => {
  const form = q(".profileFormPayer")

  if (form) {
    hyperform.setRenderer("attachWarning", function(warning, element) {
      element.parentNode.classList.add("floatInputError")
      element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
    })

    if (form.querySelector("input[type='tel']")) {
      hyperform.addValidator(form.querySelector("input[type='tel']"), element => {
        const re = /^(\+7|7|8)?[\s/\\-]?\(?[0-9]{3}\)?[\s/\\-]?[0-9]{3}[\s/\\-]?[0-9]{2}[\s/\\-]?[0-9]{2}$/gm
        const valid = re.test(element.value)
        element.setCustomValidity(
          valid ? "" : element.value ? element.dataset.typeMismatch : element.dataset.valueMissing
        )
        return valid
      })
      maskInput({
        inputElement: form.querySelector("input[type='tel']"),
        mask: ["+", /[1-9]/, " ", "(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
        showMask: false,
        keepCharPositions: false
      })
    }

    hyperform(form)

    switchForm(form, safeGet(["PERSON_TYPE_ID"], NSerializeJson.serializeForm(form)))
    form.addEventListener("change", () => {
      const formData = NSerializeJson.serializeForm(form)
      const getPayerType = safeGet(["PERSON_TYPE_ID"], formData)
      if (getPayerType && state.part !== getPayerType) switchForm(form, getPayerType)
    })
  }
}

const switchPoseProps = {
  initialPose: "closed",
  open: {
    opacity: 1,
    y: 0,
    applyAtStart: { display: "block" }
  },
  closed: {
    opacity: 0,
    y: 50,
    applyAtEnd: { display: "none" }
  }
}

const switchForm = (form, payerType) => {
  const formParts = qq(".personTypeForm", form)

  // init popmotion
  const posers = {}
  state.part = payerType
  formParts.map((part, index) => {
    posers[index + 1] = pose(part, switchPoseProps)
  })

  posers[payerType].set("open")
}
